import React, { useEffect, useState } from "react";

import { findField } from "components/attributes/compare-table/field-builder";
import ReadOnlyField from "components/attributes/compare-table/read-only-field";
import AttributeInputField from "components/attributes/compare-table/attribute-input-field";
import DisplayGroup from "./display-group";
import SaveGroup from "./save-group";
import { useAttributeGroups } from "shared/hooks/api/use-attribute-groups";

const SELECT_CLASS = "-highlight-selected";
//File needs more refactoring
export const AttributeGroupItem = ({ attribute, parentAttribute, readOnly, defaultValue, updateOnChange, hasValue, disabled, wipKey = "" }) => {
    const [attributeGroups, setAttributeGroups] = useState([]);
    const [selectedId, setSelectedId] = useState(null);
    const [hasReset, setHasReset] = useState(false);
    const [hideField, setHideField] = useState(false);

    const parentGroup = attribute.additionalInfo.parentGroupInfo.parentGroupName;
    const { data: groups, isSuccess } = useAttributeGroups([parentGroup]);

    useEffect(() => {
        if (isSuccess) {
            setAttributeGroups(groups);
        }
    }, [groups, isSuccess]);

    useEffect(() => {
        if (!hasValue) {
            setSelectedId(null);
            readOnly && setHideField(true);
        } else {
            setHideField(false);
        }
    }, [hasValue, readOnly]);

    useEffect(() => {
        document.getElementById(selectedId)?.classList.add(SELECT_CLASS);
        Array.from(document.querySelectorAll(`.${SELECT_CLASS}`)).forEach((el) => el.id !== selectedId && el.classList.remove(SELECT_CLASS));
    }, [selectedId]);

    const handleEditGroup = (values, id) => {
        setHasReset(true);

        if (disabled || readOnly) {
            return;
        }

        setHasReset(true);

        if (selectedId === id) {
            return setSelectedId(null);
        }

        const groupsWithValues = attributeGroups.map((attr) => {
            attr.defaultValue = values[attr.uuid];

            return attr;
        });
        setAttributeGroups(groupsWithValues);
        setSelectedId(id);
    };

    const fields = attributeGroups.map((attr) => {
        const subGroup = attr.additionalInfo && attr.additionalInfo.parentGroupInfo ? attr.additionalInfo.parentGroupInfo.parentGroupName : null;

        if (subGroup) {
            return (
                <AttributeGroupItem
                    key={`AG_${attr.uuid}`}
                    uuid={attr.uuid}
                    attribute={attr}
                    readOnly={readOnly}
                    disabled={disabled}
                    wipKey={wipKey}
                />
            );
        } else {
            if (readOnly) {
                return (
                    <ReadOnlyField
                        key={`ROF_${attr.uuid}`}
                        attribute={attr}
                        defaultValue={defaultValue}
                        wipKey={wipKey}
                    />
                );
            }

            const Field = findField(attr.componentType);

            return (
                <div key={`AIF_${attr.uuid}`}>
                    <label>{attr.name}</label>
                    <AttributeInputField
                        id={`AGF_${attr.uuid}`}
                        name={`AGF_${attr.uuid}`}
                        Field={Field}
                        attribute={attr}
                        isGroup={true}
                        disabled={readOnly || disabled}
                        updateOnChange={updateOnChange}
                        defaultValue={attr.defaultValue}
                        selectedId={selectedId}
                        existingValue={attr.defaultValue}
                        hasReset={hasReset}
                        setHasReset={setHasReset}
                    />
                </div>
            );
        }
    });

    if (!isSuccess) {
        return;
    }

    return (
        <div style={{ display: hideField ? "none" : "block" }}>
            <fieldset>
                <legend>{attribute.name}</legend>
                <DisplayGroup
                    uuid={attribute.uuid}
                    attribute={attribute}
                    attributeList={attributeGroups}
                    parentAttribute={parentAttribute}
                    readOnly={readOnly}
                    onEditGroup={handleEditGroup}
                    selectedId={selectedId}
                    setSelectedId={setSelectedId}
                    disabled={disabled}
                    wipKey={wipKey}
                />
                {fields}
                {!readOnly && !disabled && (
                    <SaveGroup
                        uuid={attribute.uuid}
                        attributeList={attributeGroups}
                        parentAttribute={parentAttribute}
                        selectedId={selectedId}
                        setSelectedId={setSelectedId}
                    />
                )}
            </fieldset>
        </div>
    );
};
